<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="NEWS LIST"
      background-image="/page/news-banner.jpg"
      :title="title"
      :subtitle="subtitle"
    />
    <section class="section news-list-section">
      <div class="container news-list-layout">
        <aside class="news-side">
          <div class="news-side-card">
            <div class="news-side-en">NEWS CENTER</div>
            <h2>{{ $pick(title) }}</h2>
            <p>{{ $pick(sideDescription) }}</p>
            <nav class="news-side-nav">
              <router-link
                v-for="item in newsItems"
                :key="item.path"
                :to="item.path"
                :class="{ active: $route.path === item.path }"
              >
                {{ $pick(item.label) }}
              </router-link>
            </nav>
          </div>
        </aside>

        <div class="news-main">
          <div class="news-list-head" v-reveal>
            <div class="news-list-en">OUR CIRCLE</div>
            <h3>{{ $pick(title) }}</h3>
            <span>{{ items.length }} {{ totalLabel }}</span>
          </div>

          <article
            v-for="item in items"
            :key="item.slug"
            class="news-list-card"
            v-reveal
          >
            <div class="news-list-meta">
              <span class="news-list-tag">{{ item.category === "industry" ? "行业资讯" : "本站动态" }}</span>
              <time>{{ item.date }}</time>
            </div>
            <router-link class="news-list-title" :to="item.path">
              {{ item.title }}
            </router-link>
            <p>{{ item.excerpt }}</p>
            <div class="news-list-footer">
              <span>{{ sourceLabel }}{{ item.sourceName }}</span>
              <router-link :to="item.path">{{ detailLabel }}</router-link>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import { navGroups } from "../../data/site";
import { getNewsByCategory } from "../../data/news";

export default {
  name: "NewsCategoryBase",
  components: { PageBanner },
  props: {
    title: [String, Object],
    routePath: String,
    category: String
  },
  computed: {
    newsItems() {
      return navGroups.find((item) => item.path === "/news").children;
    },
    items() {
      return getNewsByCategory(this.category).map((item) => ({
        ...item,
        path: `/news/detail/${item.slug}`
      }));
    },
    subtitle() {
      return this.category === "industry"
        ? { "zh-CN": "围绕电力变压器、电力装备与行业趋势的资讯内容", "en-US": "Industry updates around transformers, power equipment and market trends" }
        : { "zh-CN": "围绕企业参展、发货、项目交付与站内的动态内容", "en-US": "Company updates on exhibitions, shipments, project delivery and curated site news" };
    },
    sideDescription() {
      return this.category === "industry"
        ? { "zh-CN": "聚焦公开可查的行业信息、技术趋势与政策动态，帮助客户快速了解电力装备发展方向。", "en-US": "A curated feed of public industry updates, technical trends and policy direction." }
        : { "zh-CN": "汇总企业动态、发货记录、展会活动与站内整理内容，让栏目更完整也更适合后续扩充。", "en-US": "A richer list of company updates, shipments, exhibitions and curated site news." };
    },
    totalLabel() {
      return this.locale === "zh-CN" ? "条资讯" : "articles";
    },
    sourceLabel() {
      return this.locale === "zh-CN" ? "来源：" : "Source: ";
    },
    detailLabel() {
      return this.locale === "zh-CN" ? "查看详情" : "Read More";
    }
  }
};
</script>

<style scoped>
.news-list-section {
  background: linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%);
}

.news-list-layout {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: 32px;
}

.news-side-card {
  position: sticky;
  top: 132px;
  padding: 28px;
  border: 1px solid var(--line);
  border-radius: 28px;
  background: #ffffff;
  box-shadow: var(--shadow);
}

.news-side-en {
  margin-bottom: 8px;
  font-size: 40px;
  font-weight: 800;
  line-height: 0.95;
  background: linear-gradient(90deg, #1252a7 0%, #1a6fcb 50%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.news-side-card h2 {
  margin: 0 0 14px;
  font-size: 34px;
  color: #243041;
}

.news-side-card p {
  margin: 0 0 20px;
  color: #7b8492;
  line-height: 1.9;
}

.news-side-nav a {
  display: block;
  margin-bottom: 10px;
  padding: 14px 16px;
  border-radius: 16px;
  background: #f5f8fc;
  color: #3c4a5d;
  transition: transform 0.25s ease, background-color 0.25s ease, color 0.25s ease;
}

.news-side-nav a.active,
.news-side-nav a:hover {
  color: #ffffff;
  background: linear-gradient(135deg, #134f99, #1a6fcb 58%, #4f64b8);
  transform: translateY(-2px);
}

.news-list-head {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 24px;
}

.news-list-en {
  font-size: clamp(48px, 6vw, 78px);
  font-weight: 800;
  line-height: 0.95;
  background: linear-gradient(90deg, #1252a7 0%, #1a6fcb 50%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.news-list-head h3 {
  margin: 0;
  flex: 1;
  font-size: 42px;
  color: #202a39;
}

.news-list-head span {
  color: #9aa3b0;
}

.news-list-card {
  margin-bottom: 22px;
  padding: 28px;
  border: 1px solid rgba(227, 232, 240, 0.9);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 44px rgba(18, 54, 110, 0.08);
}

.news-list-meta,
.news-list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.news-list-meta {
  margin-bottom: 14px;
}

.news-list-tag {
  display: inline-flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(239, 43, 45, 0.08);
  color: #ef2b2d;
  font-size: 13px;
  font-weight: 700;
}

.news-list-meta time {
  color: #9aa3b0;
}

.news-list-title {
  display: block;
  margin-bottom: 16px;
  color: #1f2d3c;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.35;
}

.news-list-title:hover {
  color: var(--brand-blue);
}

.news-list-card p {
  margin: 0;
  color: #707b89;
  font-size: 17px;
  line-height: 1.9;
}

.news-list-footer {
  margin-top: 22px;
  color: #9aa3b0;
  font-size: 14px;
}

.news-list-footer a {
  color: #d9262d;
  font-weight: 600;
}

@media (max-width: 960px) {
  .news-list-layout {
    grid-template-columns: 1fr;
  }

  .news-side-card {
    position: static;
  }

  .news-list-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .news-list-title {
    font-size: 24px;
  }
}

@media (max-width: 520px) {
  .news-side-card,
  .news-list-card {
    padding: 20px 18px;
    border-radius: 18px;
  }

  .news-side-en,
  .news-list-en {
    font-size: 38px;
  }

  .news-side-card h2,
  .news-list-head h3 {
    font-size: 26px;
  }

  .news-side-card p,
  .news-list-card p {
    font-size: 14px;
    line-height: 1.8;
  }

  .news-list-meta,
  .news-list-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .news-list-title {
    font-size: 21px;
  }
}
</style>
